import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { FilterPreventif } from '@/modules/Preventif/services/PreventifService';

export interface FilterInterventionsPreventives {
    page?: number;
    sort?: string;
    etats?: string[];
    id: string;
    dateDebutPeriodeRechercheParDate?: string;
    dateFinPeriodeRechercheParDate?: string;
    interventionId?: number;
    siteIds?: number[];
    isBim?: boolean;
    phaseIds?: number[];
}

class SuiviInterventionPreventiveService {
    public async getSuiviInterventionsPreventives(
        params: FilterInterventionsPreventives,
        signal?: AbortSignal
    ): Promise<any> {
        return http.get(Routes.InterventionRoutes.GetInterventionsPreventives(), { params, signal });
    }
    public async getInterventionPreventive(id: number): Promise<any> {
        return http.get(Routes.InterventionRoutes.GetInterventionPreventive(id));
    }
    public async getExportXlsInterventions(params: FilterPreventif): Promise<any> {
        return http.get(Routes.PreventifRoutes.GetInterventionsPreventivesXls(), {
            params,
            responseType: 'arraybuffer',
        });
    }
}

export default new SuiviInterventionPreventiveService();
